import "./helpers/postDate";
import scrollSmooth from "./helpers/smooth-scroll.js";
import header from "./modules/header.js";
import promo from "./modules/promo.js";
import disease from "./modules/disease.js";
import composition from "./modules/composition.js";
import review from "./modules/review.js";
// import bannerScroll from "./modules/banner.js";

header();
promo();
scrollSmooth();
disease();
composition();
review();
function main() {
  // doc();
  // reviews();
  // bannerScroll();
}

if (document.documentElement.clientWidth < 480) {
  window.addEventListener("scroll", function () {
    setTimeout(main, 1000);
  }, {
    once: true,
    passive: true,
  });
} else {
  main();
}
